// This icon file is generated automatically.

import { IconDefinition } from '../types';

const LicenseBmmFilled: IconDefinition = {
  icon: {
    tag: 'svg',
    attrs: {
      viewBox: '0 0 60 30',
      'xmlns:xlink': 'http://www.w3.org/1999/xlink',
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
    },
    children: [
      { tag: 'path', attrs: { d: 'M0 0h60v30H0z' } },
      {
        tag: 'defs',
        attrs: {},
        children: [
          {
            tag: 'pattern',
            attrs: {
              height: '1',
              id: 'a',
              patternContentUnits: 'objectBoundingBox',
              width: '1',
            },
            children: [
              {
                tag: 'use',
                attrs: {
                  transform: 'matrix(.0102 0 0 .0204 0 .17)',
                  'xlink:href': '#b',
                },
              },
            ],
          },
          {
            tag: 'image',
            attrs: {
              height: '32',
              id: 'b',
              width: '98',
              'xlink:href':
                'data:image/png;base64,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',
            },
          },
        ],
      },
    ],
  },
  name: 'license-bmm',
  theme: 'filled',
};

export default LicenseBmmFilled;
